// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fixed-size-image {
    max-width: 120px; /* Set the desired width */
    max-height: 300px; /* Set the desired height */
    width: 80%;
    height: auto;
}

.img-thumbnail.rounded-circle {
    width: 150px;  /* Fixed width for all images */
    height: 150px; /* Fixed height for all images */
    object-fit: cover; /* Ensures the image covers the area nicely without stretching */
    border-radius: 50%; /* Maintains the circular shape */
}
`, "",{"version":3,"sources":["webpack://./src/Components/Developer.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB,EAAE,0BAA0B;IAC5C,iBAAiB,EAAE,2BAA2B;IAC9C,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,YAAY,GAAG,+BAA+B;IAC9C,aAAa,EAAE,gCAAgC;IAC/C,iBAAiB,EAAE,gEAAgE;IACnF,kBAAkB,EAAE,iCAAiC;AACzD","sourcesContent":[".fixed-size-image {\n    max-width: 120px; /* Set the desired width */\n    max-height: 300px; /* Set the desired height */\n    width: 80%;\n    height: auto;\n}\n\n.img-thumbnail.rounded-circle {\n    width: 150px;  /* Fixed width for all images */\n    height: 150px; /* Fixed height for all images */\n    object-fit: cover; /* Ensures the image covers the area nicely without stretching */\n    border-radius: 50%; /* Maintains the circular shape */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
